import { View } from '@frontend/components';

import { NameAndLanguageStep, PushNotificationStep } from './components';
import { useOnboarding } from './use-onboarding';

export const OnboardingView = () => {
  const onboarding = useOnboarding();
  const activeStep = onboarding.stepsRemaining[0];

  return (
    <View>
      {activeStep === 'NAME_AND_LANGUAGE' && <NameAndLanguageStep />}
      {activeStep === 'PUSH_NOTIFICATIONS' && <PushNotificationStep />}
    </View>
  );
};
